 @import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"); 
 /* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */

 :host {
  display: block;
}
a , a:visited {
  color: #b71d1d;
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: #b71d1d;
  font-size: 16px;
 }


.img-rounded-border {
  border:10px solid red;
  border-radius:10px;
}

#about-image {
  /* width: 250px; */
  /* margin-top: 20px; */
  padding:15px;
  
}

::-webkit-scrollbar {
  width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #D3D3D3; 
}

